function UpBtn() {
    function scrollUp(e) {
        e.preventDefault();
        window.scrollTo(0, 0);
    }
    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a href="#none" onClick={e => scrollUp(e)} data-target="html" className={`scroll-to-target scroll-to-top`}>
            <span className="scroll-to-top__text">Yuqoriga</span>
            <span className="scroll-to-top__wrapper"><span className="scroll-to-top__inner"></span></span>
        </a>
    )
}

export default UpBtn